import { DRAWERS, type Drawer } from '../../workers/drawers'

/**
 * The drawer picker's <select> values (Kelvo item 2), kept here in src/lib so
 * they are tested plainly rather than through a rendered component.
 *
 * Three states, never confused:
 *   ''        — nothing chosen yet. Every filing screen refuses to submit.
 *   null      — unfiled: only the owner sees it. Offered only where taking a
 *               file out of every drawer is a real choice (moving a kept file).
 *   a drawer  — that drawer.
 */
export type DrawerChoice = Drawer | null | ''

/** The <select> value standing for "unfiled". Not a drawer key, by construction. */
export const UNFILED_VALUE = '__unfiled__'

/** A choice to its <select> value. */
export function drawerChoiceValue(choice: DrawerChoice): string {
  return choice === null ? UNFILED_VALUE : choice
}

/** A <select> value back to a choice. Anything unrecognised is "nothing chosen". */
export function parseDrawerChoice(raw: string): DrawerChoice {
  if (raw === UNFILED_VALUE) return null
  return (DRAWERS as readonly string[]).includes(raw) ? (raw as Drawer) : ''
}

/** A filing screen may submit only once a real drawer is chosen. */
export function isChosenDrawer(choice: DrawerChoice): choice is Drawer {
  return choice !== '' && choice !== null
}
